import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@/components/ui/drawer.tsx';
import { setShowTopSearch, useUiStore } from '@/stores/ui.store.ts';
import { Input } from '@/components/ui/input.tsx';
import { SearchIcon, XIcon } from 'lucide-react';
import { Button } from '@/components/ui/button.tsx';
import { type FormEvent, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';

export function TopSearchDrawer() {
  const showTopSearch = useUiStore(state => state.showTopSearch);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const searchValue = search.trim();
    if (searchValue !== '') {
      await navigate({ to: '/products', search: { q: searchValue } } as any);
      setShowTopSearch(false);
      setSearch('');
    }
  };
  return (
    <Drawer open={showTopSearch} onOpenChange={(open) => setShowTopSearch(open)} direction="top">
      <DrawerTitle className='sr-only'>Search Sacco Carpet Products</DrawerTitle>
      <DrawerDescription className='hidden'>Search Sacco Carpet Products</DrawerDescription>
      <DrawerContent className='bg-gray-950 shadow-gray-900 border-gray-800 py-12 text-white px-4'>
        <form className="h-full" onSubmit={onSubmit}>
          <div className="flex items-center justify-between max-w-3xl mx-auto h-full">
            <div className="relative grow max-w-xl">
              <Input
                placeholder="Search..."
                className="pr-8 input-no-border"
                value={search}
                autoFocus={true}
                onChange={(e) => setSearch(e.target.value)}
              />
              <SearchIcon className="absolute right-2 top-2.5 h-4 w-4 text-white cursor-pointer" onClick={onSubmit} />
            </div>
            <Button variant="ghost" type="button" onClick={() => setShowTopSearch(false)} className="text-white">
              <XIcon />
            </Button>
          </div>
        </form>
      </DrawerContent>
    </Drawer>
  );
}